import script from "./AddSalesRebateSchema.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddSalesRebateSchema.vue?vue&type=script&setup=true&lang=ts"

import "./AddSalesRebateSchema.vue?vue&type=style&index=0&id=02cf09b8&lang=css"

const __exports__ = script;

export default __exports__